<template>
  <div
    class="modal fade"
    :id="modalId"
    tabindex="-1"
    :aria-labelledby="`${modalId}Label`"
    aria-hidden="true"
  >
    <div :class="['modal-dialog', center ? 'modal-dialog-centered' : '']">
      <div class="modal-content">
        <div class="modal-header">
          <p class="fw-bold modal-title fsize-16" :id="`${modalId}Label`">
            {{ title }}
          </p>
        </div>
        <div class="modal-body">
          <div class="row mb-3">
            <label class="col-lg-12 col-form-label fw-bold text-start">
              {{ text }}
            </label>
          </div>
          <div v-if="withInput" class="col-lg-12">
            <textarea
              class="form-control"
              rows="5"
              :value="value"
              :placeholder="placeholder"
              @change="handleChange"
            ></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary bg-white text-body fw-bold me-3 border border-0 text-uppercase"
            data-bs-dismiss="modal"
          >
            {{ buttonConfig.cancelText }}
          </button>
          <button
            type="button"
            class="btn btn-secondary bg-white fw-bold text-danger border border-0 text-uppercase"
            data-bs-dismiss="modal"
            @click="handleClick"
          >
            {{ buttonConfig.confirmText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modalId: {
      type: String,
      required: true,
    },
    center: [String, Boolean],
    title: {
      type: String,
      default: "Alert",
    },
    text: {
      type: String,
      default: "Text here...",
    },
    withInput: Boolean,
    value: String,
    placeholder: {
      type: String,
      default: "Text here...",
    },
    buttonConfig: {
      type: Object,
      default() {
        return { cancelText: "Cancel", confirmText: "Yes" };
      },
    },
  },
  methods: {
    handleClick() {
      this.$emit("onClick");
    },
    handleChange(e) {
      const { target } = e;
      this.$emit("onChange", target.value);
    },
  },
};
</script>

<style></style>
